<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from '../i18n'
import { changeOwnPassword, session } from '../session'

const router = useRouter()
const route = useRoute()
const { t } = useI18n()
const currentPassword = ref('')
const newPassword = ref('')
const repeatPassword = ref('')
const loading = ref(false)
const error = ref('')

async function submit() {
  error.value = ''
  if (newPassword.value !== repeatPassword.value) {
    error.value = t('passwordMismatch')
    return
  }
  loading.value = true
  try {
    await changeOwnPassword(currentPassword.value, newPassword.value)
    await router.push(route.query.redirect || '/')
  } catch (cause) {
    error.value = cause.message
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <section class="narrow card">
    <p class="eyebrow">{{ session.user?.mustChangePassword ? t('passwordAction') : t('passwordSecurity') }}</p>
    <h1>{{ t('passwordTitle') }}</h1>
    <p class="muted">{{ t('passwordHint') }}</p>
    <form class="form-stack" @submit.prevent="submit">
      <label>{{ t('currentPassword') }} <input v-model="currentPassword" type="password" autocomplete="current-password" required /></label>
      <label>{{ t('newPassword') }} <input v-model="newPassword" type="password" autocomplete="new-password" minlength="10" required /></label>
      <label>{{ t('repeatPassword') }} <input v-model="repeatPassword" type="password" autocomplete="new-password" minlength="10" required /></label>
      <p v-if="error" class="notice error" role="alert">{{ error }}</p>
      <button class="button" :disabled="loading" type="submit">{{ loading ? t('saving') : t('savePassword') }}</button>
    </form>
  </section>
</template>
